import React, { useEffect, useState, Fragment, useMemo, useCallback } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Tooltip, Popconfirm, Select, Radio, Dropdown, Menu, Checkbox, Tag, Modal, Popover, Space,
  Drawer,
  Spin,
  Divider,
} from 'antd';
import {
  LoadingOutlined, FilterOutlined, ControlOutlined, CopyOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import ucIcon from '@Images/icons/unicommerce-icon.png';
import H3Text from '@Uilib/h3Text';
import SOActions from '@Actions/sales/soActions';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import ShopifyIcon from '@Images/admin/integrations/shopify-icon.png';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate, CountryCodes } from '@Apis/constants';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import H3DateSelector from '@Uilib/h3DateSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import BulkSOActions from '@Components/Sales/SalesOrder/SalesOrderList/BulkActions';
import TagSelector from '@Components/Common/Selector/TagSelector';
import SelectUser from '@Components/Common/SelectUser';
import TenantActions from '@Actions/tenantActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Ai from '@Images/ai.png';
import ProductActions from '@Actions/productActions';
import SelectStatus from '../../../Common/SelectCustomStatus';
import OCRFileUploader from '../../../Common/OCRFileUploader';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './mobileListHelper';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import UserSavedFilterViewSelector from '@Components/Common/UserSavedFilterViewSelector';
import PRZSelect from '../../../Common/UI/PRZSelect';
import {
  dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums,
} from '../../../../apis/constants';
import './style.scss';

const { Option } = Select;

const fixedColumns = ['SO_CODE', 'CUSTOMER', 'ORDER_TOTAL'];

function SalesOrderList({
  salesOrders, getSOLoading, salesEstimate, getEstimateLoading, user, getSO, history, syncSOLoading, syncSO, syncShopifyOrders, syncShopifyOrdersLoading, getCustomStatus, downloadSoListLoading, downloadSoList, getOrgUsers, orgUsers, getProductsLoading, getProducts, products,
  getDocCFV2, customFieldsSalesOrder, customFieldsSalesEstimate, getDocCFV2Loading, departments, getDocCFV2Success, MONEY, updateSOStatus, updateSOStatusLoading, customStatusSalesOrder, getCustomStatusSalesOrderLoading, SoFromMrp, customStatusSalesEstimate, getCustomStatusSalesEstimateLoading, priceMasking, customFieldsSalesOrderAMC,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [shopifyKeyword, setShopifyKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [shopifySearchKeyword, setShopifySearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [open, setOpen] = useState(false);
  const [call, setCall] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCustomStatus, setSelectedCustomStatus] = useState(null);
  const [fulfillmentStatus, setFulfillmentStatus] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCustomStatusId, setSelectedCustomStatusId] = useState('');
  const [selectedTag, setSelectedTag] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [openPopover, setOpenPopover] = useState(false);
  const [reportType, setReportType] = useState('document_level');
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [ocrDrawer, setOcrDrawer] = useState(false);
  const [searchByProduct, setSearchByProduct] = useState('');
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [sourceTenantId, setSourceTenantId] = useState([]);
  const [isModalProductNameOpen, setIsModalProductNameOpen] = useState(false);
  const [selectedOrderType, setSelectedOrderType] = useState(null);

  const [documentUINames, setDocumentUINames] = useState({
    uiName: (window.location.href.includes('/estimate')) ? 'Estimate' : 'Sales Order',
    shortUIName: (window.location.href.includes('/estimate')) ? 'Estimate' : 'SO',
    salesOrderUIName: 'Sales Order',
    salesOrderShortUIName: 'SO',
    estimateUIName: 'Estimate',
    estimateShortUIName: 'Estimate',
  });

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-so') ? JSON.parse(localStorage.getItem('prcz-page-columns-so')) : {
    SO_CODE: {
      // label: isEstimate ? 'ESTIMATE #' : 'SO #',
      label: `${documentUINames.shortUIName.toUpperCase()} #`,
      visible: true,
    },
    CUSTOMER: {
      label: 'Customer',
      visible: true,
    },
    LINKED_MO: {
      label: 'Linked MO',
      visible: false,
    },
    ORDER_TOTAL: {
      label: 'Order Total',
      visible: true,
    },
    SHOPIFY_CODE: {
      label: 'Shopify #',
      visible: true,
    },
    SHOPIFY_SOURCE: {
      label: 'Shopify Source',
      visible: false,
    },
    ITEMS: {
      label: 'Items',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: false,
    },
    ORDER_DATE: {
      label: 'Order Date',
      visible: true,
    },
    FULFILLMENT_STATUS: {
      label: 'Fulfillment Status',
      visible: true,
    },
    PAYMENT_STATUS: {
      label: 'Payment Status',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    LABEL: {
      label: 'Label',
      visible: true,
    },
    SALES_MANAGER: {
      label: 'Sales Manager',
      visible: true,
    },
    MRP_NUMBER: {
      label: 'MRP Number',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
  });
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [isEstimate, setIsEstimate] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const fulfillmentStatues = [
    { value: 'pending', label: 'Pending' },
    { value: 'fulfilled', label: 'Fulfilled' },
    { value: 'partial', label: 'Partial' },
  ];
  const paymentStatues = [
    { value: 'PAID', label: 'Paid' },
    { value: 'NOT_PAID', label: 'Not Paid' },
    { value: 'PARTIALLY_PAID', label: 'Partially Paid' },
    { value: 'PAID_MORE', label: 'Paid More' },
  ];

  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];

  const getCustomFieldsProps = () => {
    if (window.location.href.includes('/estimate')) {
      return customFieldsSalesEstimate;
    }

    const customFieldsSO = customFieldsSalesOrder?.data?.document_custom_fields;
    const customFieldsAMC = customFieldsSalesOrderAMC?.data?.document_custom_fields;

    if (customFieldsSO?.length > 0 && customFieldsAMC?.length > 0) {
      const mergedData = {
        data: {
          document_custom_fields: [
            ...customFieldsSO,
            ...customFieldsAMC
          ].filter(
            (item, index, self) =>
              index === self.findIndex((obj) => obj.cf_id === item.cf_id)
          ),
        }
      };
      return mergedData;
    }

    return customFieldsSalesOrder;
  };
  useEffect(() => {
    // Start a timer with the debounce delay
    const handler = setTimeout(() => {
      if (searchByProduct) {
        getProducts(searchByProduct, user?.tenant_info?.tenant_id, '', 5, 1, '', '', '', '', '', '', '');
      }
    }, 500); // 500ms debounce time
    // Cleanup function to clear the timer
    return () => {
      clearTimeout(handler);
    };
  }, [searchByProduct]);

  const handleChange = (value, option) => {
    setSelectedProductIds(value);
    setSelectedProducts(option);
  };

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const getSalesOrderColumns = () => {
    const salesColumns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                >
                  <PRZText
                    text={`#${record?.sales_order_number}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  className="mobile-list__card__status"
                  style={{
                    backgroundColor: record?.custom_status_info?.color_code,
                  }}
                  text={record?.custom_status_info?.status_name?.replaceAll('_', ' ').toProperCase()}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                {record?.customer_info?.customer_name ? (
                  <div className="mobile-list__card_item-name_wrapper">
                    <Tooltip
                      title={
                        Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
                          Helpers.permissionTypes.READ, user)
                          ? (
                            <Link
                            // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                            >
                              <PRZText
                                className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                                text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                              />
                            </Link>
                          ) : (
                            <PRZText
                              className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                              text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                            />
                          )
                      }
                      color="white"
                    >
                      <PRZText text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`} className="mobile-list__card_item-name" />
                    </Tooltip>
                  </div>
                ) : '-'}

                <PRZText text={`${documentUINames.shortUIName?.toUpperCase()} Date: ${dayjs(record?.order_date).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Location: ${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name})`} className="mobile-list__card_item-details" />
                </Tooltip>

                <PRZText text={`Sales Manager: ${record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : 'N/A'}`} className="mobile-list__card_item-details" />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${dayjs(record?.created_at).format('DD/MM/YYYY')} ( ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Created By ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'} on ${dayjs(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details created_by_info" />
                </Tooltip>

              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text={`${documentUINames.shortUIName.toUpperCase()} Total`} />
                  )}
                >
                  <PRZText
                    text={(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={`You don't have access to view ${documentUINames.shortUIName.toLowerCase()} total`} /> : MONEY((record?.order_grand_total || '0'), record?.org_currency_info?.currency_code)}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                {!isEstimate && (
                  <Tooltip
                    color="white"
                    title={(
                      <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Fulfillment Status" />
                    )}
                  >
                    <PRZText
                      className="mobile-list__card_footer__other-status font-11"
                      style={{ color: Helpers.getStatusColor(record?.shopify_order_id ? (record?.shopify_fulfillment_status?.toUpperCase() || 'PENDING') : (record?.fulfillment_status?.toUpperCase()))?.color }}
                      text={record?.shopify_order_id ? (record?.shopify_fulfillment_status?.replaceAll('_', ' ').toProperCase() || 'PENDING') : (record?.fulfillment_status?.replaceAll('_', ' ').toProperCase())}
                    />
                  </Tooltip>

                )}
                {!isEstimate && (
                  <Tooltip
                    color="white"
                    title={(
                      <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Payment Status" />
                    )}
                  >
                    <PRZText
                      className="mobile-list__card_footer__other-status font-11"
                      style={{ color: Helpers.getStatusColor(record?.payment_status)?.color }}
                      text={record.payment_status?.replaceAll('_', ' ')?.toProperCase()}
                    />
                  </Tooltip>
                )}
                <div className="mobile-list__card_footer__actions-button_wrapper">
                  {!isEstimate && record?.zoho_order_id && (
                    <div className="card_footer__actions-button">
                      <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                        <img
                          alt="zoho"
                          className="img-zoho card_footer__actions-button_image"
                          src={ZohoBooks}
                        />
                      </div>
                    </div>
                  )}
                  {!isEstimate && user?.tenant_info?.unicommerce_domain_name && record?.unicommerce_so_code && (
                    <Popconfirm
                      title={`Order last synced from unicommerce on ${record?.unicommerce_last_sync && toISTDate(record?.unicommerce_last_sync).format('DD/MM/YYYY hh:mm A')}`}
                      okText="Sync Again"
                      okButtonProps={{
                        hidden: true,
                      }}
                      cancelButtonProps={{
                        hidden: true,
                      }}
                    >
                      <div className="card_footer__actions-button">
                        <img
                          alt="unicommerce"
                          className="unicommerce-button card_footer__actions-button_image"
                          src={ucIcon}
                        />
                      </div>
                    </Popconfirm>
                  )}
                </div>
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedOrder(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        // title: isEstimate ? 'ESTIMATE #' : 'SO #',
        title: `${documentUINames.shortUIName.toUpperCase()} #`,
        // dataIndex: 'sales_order_number',
        render: (record) => (
          <div className={`column-number__wrapper ${Helpers.setColumnMinimumWidth(`${documentUINames.shortUIName} #`)}`}>
            {record?.sales_order_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SO_CODE?.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'LINKED MO',
        render: (text, record) => (
          <div className="min-width-70">
            {record?.linked_mo?.map((item) => (
              <div
                className="associated-entity"
                key={item?.mo_id}
              >
                <Link to={`/production/manufacturing-orders/view/${item?.mo_id}`} target="_blank">
                  {item?.mo_number}
                </Link>
              </div>
            ))}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: (isEstimate || !visibleColumns?.LINKED_MO?.visible) ? 'display-none' : '',
      },
    ];
    if (user?.tenant_info?.shopify_location_id) {
      salesColumns.push({
        title: 'SHOPIFY #',
        key: 'action2',
        render: (text, record) => (
          <div className="min-width-70">
            {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.shopify_location_id && (
              <div>
                {(record?.shopify_order_id)
                  ? (
                    <Tooltip
                      title={`Order placed on ${dayjs(record?.shopify_created_at).format('DD/MM/YYYY hh:mm A')}`}
                      overlayClassName="font-12"
                      placement="topRight"
                    >
                      <a
                        href={`https://admin.shopify.com/store/${record?.shopify_shop_name?.split('.')?.[0]}/orders/${record?.shopify_order_id}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {record?.shopify_order_number}
                      </a>

                    </Tooltip>
                  )
                  : <div />}
              </div>
            )}
          </div>
        ),
        className: (isEstimate || !visibleColumns?.SHOPIFY_CODE?.visible) ? 'display-none' : '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      }, {
        title: 'SHOPIFY SOURCE',
        render: (record) => (
          <div className="min-width-85">
            {record?.order_client_source?.source}
          </div>
        ),
        className: (isEstimate || !visibleColumns?.SHOPIFY_SOURCE?.visible) ? 'display-none' : '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      });
    }
    const fixedColumn = [
      {
        title: 'CUSTOMER',
        render: (text, record) => (
          <div className="associated-entity min-width-70">
            {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
              Helpers.permissionTypes.READ, user)
              ? (record?.customer_info?.customer_name ? (
                <Link to={`/sales/customer/view/${record?.customer_id}`} target="_blank">
                  {`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                </Link>
              ) : '-') : (`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CUSTOMER?.visible ? 'display-none' : '',
      },
      {
        title: 'SALES MANAGER',
        render: (text, record) => (
          <div className="min-width-115">
            {record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SALES_MANAGER?.visible ? 'display-none' : '',
      },
      {
        title: 'LOCATION',
        render: (text, record) => (
          <div className="min-width-70">
            {record?.tenant_info?.tenant_name}
            <H3Text text={record?.tenant_department_info?.department_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEMS',
        render: (item) => (
          <div className="min-width-50">
            {item?.line_count || 0}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (record) => (
          <div className="min-width-100">
            <div className="column-date">
              {dayjs(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        // title: isEstimate ? 'ESTIMATE DATE' : 'SO DATE',
        title: `${documentUINames.shortUIName.toUpperCase()} DATE`,
        render: (record) => (
          <div className={`column-date ${Helpers.setColumnMinimumWidth(`${documentUINames.shortUIName} DATE`)}`}>
            {dayjs(record?.order_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ORDER_DATE?.visible ? 'display-none' : '',
      },
      {
        // title: isEstimate ? 'ESTIMATE TOTAL' : 'SO TOTAL',
        title: `${documentUINames.shortUIName.toUpperCase()} TOTAL`,
        render: (item, record) => (
          <div className={`${Helpers.setColumnMinimumWidth(`${documentUINames.shortUIName} TOTAL`)}`}>
            {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={`You don't have access to view ${documentUINames.shortUIName.toLowerCase()} total`} /> : MONEY((record?.order_grand_total || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ORDER_TOTAL?.visible ? 'display-none' : '',
      },
      {
        title: 'FULFILLMENT STATUS',
        render: (item) => (
          <div className="min-width-130">
            <div
              className="shopify-order-statuses"
              style={{ color: Helpers.getStatusColor(item?.shopify_order_id ? (item?.shopify_fulfillment_status?.toUpperCase() || 'PENDING') : (item?.fulfillment_status?.toUpperCase()))?.color }}
            >
              {item?.shopify_order_id ? (item?.shopify_fulfillment_status?.replaceAll('_', ' ').toUpperCase() || 'PENDING') : (item?.fulfillment_status?.replaceAll('_', ' ').toUpperCase())}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.FULFILLMENT_STATUS?.visible || isEstimate ? 'display-none' : '',
      },
      {
        title: 'PAYMENT STATUS',
        render: (item) => (
          <div className="min-width-115">
            <div
              className="shopify-order-statuses"
              style={{ color: Helpers.getStatusColor(item?.payment_status)?.color }}
            >
              {item.payment_status?.replaceAll('_', ' ')}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PAYMENT_STATUS?.visible || isEstimate ? 'display-none' : '',
      },
      {
        title: 'LINKED MRP',
        render: (text, record) => (
          <div className="associated-entity min-width-85">
            {record?.mrp_id ? (
              <Link to={`/production/planning/v2/view/${record?.mrp_id}`} target="_blank">
                {record?.mrp_number}
              </Link>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: (isEstimate || !visibleColumns?.MRP_NUMBER?.visible) ? 'display-none' : '',
      },
      {
        title: 'LINKED MR',
        render: (item) => (
          <Fragment>
            <div className="associated-entity min-width-70">
              {item?.linked_prs ? item?.linked_prs?.map((linkedPr) => (
                <Link style={{ display: 'block' }} key={linkedPr?.pr_number} to={`/purchase/purchase-request/view/${linkedPr?.purchase_requisition_id}`} target="_blank">
                  {linkedPr?.pr_number}
                </Link>
              )) : '-'}
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PAYMENT_STATUS?.visible || isEstimate ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'LABELS',
        render: (item) => (
          <div className="min-width-70">
            <div className="table-labels__list">
              <div>
                <Space size={[0, 8]} wrap>
                  {item?.tags?.map((tag, index) => (
                    <Tag
                      key={index}
                      color={colorArray[index]}
                    >
                      {tag}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LABEL?.visible ? 'display-none' : '',
      },
    ];
    salesColumns.push(...fixedColumn);
    if (getCustomFieldsProps()?.data?.document_custom_fields?.length) {
      const customs = getCustomFieldsProps()?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.filter((item) => item?.is_active)?.map((custom) => {
        salesColumns.push({
          title: custom?.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record?.custom_fields?.filter((subItem) => subItem?.cf_id === custom?.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom?.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    const addAlpha = (color, opacity) => {
      // coerce values so ti is between 0 and 1.
      const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    };
    salesColumns.push({
      title: '',
      key: 'action',
      render: (record) => (
        <div className="list__actions">
          {!isEstimate && record?.zoho_order_id && (
            <div className="list__actions-button">
              <div className="img-zoho__wrapper">
                <img
                  alt="zoho"
                  className="img-zoho"
                  src={ZohoBooks}
                />
              </div>
            </div>
          )}
          {!isEstimate && user?.tenant_info?.unicommerce_domain_name && record?.unicommerce_so_code && (
            <Popconfirm
              placement="topRight"
              title={`Order last synced from unicommerce on ${record?.unicommerce_last_sync && toISTDate(record?.unicommerce_last_sync).format('DD/MM/YYYY hh:mm A')}`}
              okText="Sync Again"
              okButtonProps={{
                hidden: true,
              }}
              cancelButtonProps={{
                hidden: true,
              }}
            >
              <div className="list__actions-button">
                <img
                  alt="unicommerce"
                  className="unicommerce-button"
                  src={ucIcon}
                />
              </div>
            </Popconfirm>
          )}

          <div className="list__actions-button list__actions-status-selector">
            <SelectStatus
              selectedCustomStatus={record?.custom_status_id}
              hideTitle
              tenantId={selectedTenant?.join(',')}
              posibleStatuses={[record?.custom_status_info, ...record?.possible_status]}
              onChange={(value) => {
                updateSOStatus({
                  status: value?.type,
                  secondary_status: value?.status_name,
                  order_id: record?.order_id,
                  custom_status_id: value?.custom_status_id,
                }, () => {
                  setCall(!call);
                });
              }}
              disabled={['VOID', 'SENT_FOR_APPROVAL'].includes(record?.custom_status_info?.type) || !record?.custom_status_id}
              customStyle={{
                color: record?.custom_status_info?.color_code,
                backgroundColor: addAlpha(record?.custom_status_info?.color_code, 0.9),
                fontSize: '11px',
                height: '50px',
              }}
              dropdownAlign={{ offset: [0, 12] }}
            />
          </div>
          {!isPortrait && (
            <React.Fragment>
              <div
                className="list__actions-button list__actions-button-dark"
                onClick={() => {
                  if (isEstimate) {
                    history.push(`/sales/estimate/view/${record?.order_id}`);
                  } else {
                    record?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ?
                      history.push(`/sales/amc-sales-order/view/${record?.order_id}`) :
                      history.push(`/sales/sales-order/view/${record?.order_id}`);
                  }
                }}
              >
                View
              </div>
              <Tooltip
                placement="topLeft"
                title="Make a Copy"
              >
                <div
                  className={`list__actions-button ${(record?.shopify_order_id || record?.unicommerce_so_code) ? 'list__actions-button-download-disabled' : ''}`}
                  onClick={() => {
                    if (!record?.shopify_order_id && !record?.unicommerce_so_code) {
                      if (isEstimate) {
                        history.push({
                          pathname: '/sales/estimate/create',
                          state: {
                            cloneSo: record?.order_id,
                            selectedTenantIdSo: record?.tenant_id,
                          },
                        });
                      } else {
                        history.push({
                          pathname: '/sales/sales-orders/create',
                          state: {
                            cloneSo: record?.order_id,
                            selectedTenantIdSo: record?.tenant_id,
                          },
                        });
                      }
                    }
                  }}
                >
                  <CopyOutlined
                    style={{
                      fontSize: '16px',
                    }}
                  />
                </div>
              </Tooltip>
            </React.Fragment>
          )}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      fixed: 'right',
      className: 'list__actions-column',
    });

    return salesColumns.filter((item) => !item.hidden);
  };

  const pushParamsToUrl = (page, limit, word, status, fulfillmentStatus, paymentStatus, currentTenant, startDate, endDate, dept, customStatus, customStatusId, shopifyWord, tags, accountManager, sourceTenantIdParams, selectedOrderType, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    url += '&list_screen=true';
    if (limit) url += `&limit=${limit}`;
    if (word) url += `&keyword=${word}`;
    if (shopifyWord) url += `&shopify_keyword=${encodeURIComponent(shopifyWord)}`;
    if (status) url += `&status=${status}`;
    if (sourceTenantIdParams) url += `&source_tenant_id=${sourceTenantIdParams}`;
    if (customStatus) url += `&custom_status=${customStatus}`;
    if (customStatusId) url += `&custom_status_id=${customStatusId}`;
    if (fulfillmentStatus) url += `&fulfillment_status=${fulfillmentStatus}`;
    if (paymentStatus) url += `&payment_status=${paymentStatus}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (dept) url += `&department=${dept}`;
    if (tags) url += `&label=${tags}`;
    if (accountManager) url += `&accountManager=${selectedAssignee?.map((item) => (item?.userId))?.join(',')}`;
    if (selectedOrderType) url += `&order_type=${selectedOrderType}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getOrderDataLoading() {
    if (window.location.href.includes('/estimate')) {
      return getEstimateLoading;
    }
    return getSOLoading;
  }

  function getOrderData() {
    if (window.location.href.includes('/estimate')) {
      return salesEstimate;
    }
    return salesOrders;
  }

  const getSelectedOrderType = useMemo(() => {
    let orderType;
    if (Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) && Helpers.getPermission(Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT, Helpers.permissionTypes.READ, user) && (user?.tenant_info?.sales_config?.sub_modules?.sales_order?.is_active && user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.is_active)) {
      orderType = null;
    } else if ((Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) && user?.tenant_info?.sales_config?.sub_modules?.sales_order?.is_active) && !(Helpers.getPermission(Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT, Helpers.permissionTypes.READ, user) && user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.is_active)) {
      if (window.location.href.includes('/estimate')) {
        orderType = 'SALES_ESTIMATE';
      } else {
        orderType = 'SALES_ORDER';
      }
    } else if ((Helpers.getPermission(Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT, Helpers.permissionTypes.READ, user) && user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.is_active) && !(Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) && user?.tenant_info?.sales_config?.sub_modules?.sales_order?.is_active)) {
      if (window.location.href.includes('/estimate')) {
        orderType = 'SALES_ESTIMATE';
      } else {
        orderType = 'ANNUAL_MAINTENANCE_CONTRACT';
      }
    }
    return orderType;
  }, [user]);

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    // const restrictAccountManagerPermissionCheck = (window.location.href.includes('/estimate')) ? (user?.tenant_info?.sales_config?.sub_modules?.sales_estimate?.settings?.restrict_estimate_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_estimate)) : (user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.restrict_orders_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_so));

    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'shopify_keyword',
        filter_value: (Helpers.getValueFromUrl('shopify_keyword') && decodeURIComponent(Helpers.getValueFromUrl('shopify_keyword'))) || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status',
        filter_value: Helpers.getValueFromUrl('custom_status') || null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: Number(Helpers.getValueFromUrl('custom_status_id')) || null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'fulfillment_status',
        filter_value: Helpers.getValueFromUrl('fulfillment_status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'payment_status',
        filter_value: Helpers.getValueFromUrl('payment_status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'label',
        filter_value: Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'accountManager',
        filter_value: Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim() || '',
          identity: parseInt(item) == 0 ? 'UA' : orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase() || '',
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department',
        filter_value: Number(Helpers.getValueFromUrl('department')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'source_tenant_id',
        filter_value: Number(Helpers.getValueFromUrl('source_tenant_id')) || [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'order_type',
        filter_value: Helpers.getValueFromUrl('order_type') || null,
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    const restrictAccountManagerPermissionCheck = (window.location.href.includes('/estimate')) ? (user?.tenant_info?.sales_config?.sub_modules?.sales_estimate?.settings?.restrict_estimate_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_estimate)) : (user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.restrict_orders_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_so));

    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'shopify_keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status',
        filter_value: null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'fulfillment_status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'payment_status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'label',
        filter_value: [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'endDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'accountManager',
        filter_value: restrictAccountManagerPermissionCheck ? [{
          userId: user?.user_id,
          title: `${user?.first_name} ${user?.last_name}`?.trim(),
          identity: user?.first_name?.substring(0, 2).toUpperCase(),
        }] : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department',
        filter_value: Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility ? Number(Helpers.getDepartmentId(user)) : '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'source_tenant_id',
        filter_value: [],
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'order_type',
        filter_value: getSelectedOrderType,
        filter_type: filterTypeEnums.STRING,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: (window.location.href.includes('/estimate')) ? entityNameEnum.SALES_ESTIMATE : entityNameEnum.SALES_ORDER,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (user?.tenant_info) {
      setIsEstimate(!!(window.location.href.includes('/estimate')));
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, (window.location.href.includes('/estimate')) ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
        // setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
        //   userId: parseInt(item),
        //   title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
        //   identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        // })) : []);
      });
      getCustomStatus({
        entityName: (window.location.href.includes('/estimate')) ? 'SALES_ESTIMATE' : 'SALES_ORDER',
        orgId: user?.tenant_info?.org_id,
      }, () => { });
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: (window.location.href.includes('/estimate')) ? 'SALES_ESTIMATE' : 'SALES_ORDER',
      };
      getDocCFV2(payload);
      getDocCFV2({
        orgId: user?.tenant_info?.org_id,
        entityName: 'ANNUAL_MAINTENANCE_CONTRACT',
      });
      setSelectedFilterView(systemDefaultUserView);
    }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setSelectedEmails([user?.email]);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setShopifySearchKeyword(tempFilterValues.shopify_keyword);
        setKeyword(tempFilterValues.keyword);
        setShopifyKeyword(tempFilterValues.shopify_keyword);
        setSelectedCustomStatus(tempFilterValues.custom_status);
        setSelectedCustomStatusId(tempFilterValues.custom_status_id);
        setFulfillmentStatus(tempFilterValues.fulfillment_status);
        setPaymentStatus(tempFilterValues.payment_status);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedTag(tempFilterValues.label);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSelectedAssignee(tempFilterValues.accountManager);
        setSelectedOrderType(tempFilterValues.order_type);
        setSelectedDepartment(tempFilterValues.department);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          // setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
        } else {
          // setSelectedDepartment(Helpers.getValueFromUrl('department'));
        }

        const tempDocumentUINames = documentUINamesConstant(user);

        setDocumentUINames({
          uiName: (window.location.href.includes('/estimate')) ? tempDocumentUINames.estimateUIName : tempDocumentUINames.salesOrderUIName,

          shortUIName: (window.location.href.includes('/estimate')) ? tempDocumentUINames.estimateShortUIName : tempDocumentUINames.salesOrderShortUIName,

          salesOrderUIName: tempDocumentUINames.salesOrderUIName,

          salesOrderShortUIName: tempDocumentUINames.salesOrderShortUIName,

          estimateUIName: tempDocumentUINames.estimateUIName,

          estimateShortUIName: tempDocumentUINames.estimateShortUIName,
        });
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (getCustomFieldsProps()?.data?.document_custom_fields?.length) {
      const customFields = getCustomFieldsProps()?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-so'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, []);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedStatus, fulfillmentStatus, paymentStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedCustomStatus, selectedCustomStatusId, shopifySearchKeyword && shopifySearchKeyword.replace(/\s/g, ''), selectedTag, selectedAssignee, sourceTenantId, selectedOrderType, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getSO({
        orgId: user?.tenant_info?.org_id,
        tenantId: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, (window.location.href.includes('/estimate')) ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','),
        status: Helpers.getValueFromUrl('status'),
        page: Helpers.getValueFromUrl('page'),
        limit: Helpers.getValueFromUrl('limit'),
        searchKeyword: Helpers.getValueFromUrl('keyword'),
        fulfillmentStatus: Helpers.getValueFromUrl('fulfillment_status'),
        startDate: Helpers.getValueFromUrl('startDate'),
        endDate: Helpers.getValueFromUrl('endDate'),
        departmentId: Helpers.getValueFromUrl('department'),
        listScreen: Helpers.getValueFromUrl('list_screen'),
        paymentStatus: Helpers.getValueFromUrl('payment_status'),
        secondaryStatus: Helpers.getValueFromUrl('custom_status'),
        shopifySearchKeyword: Helpers.getValueFromUrl('shopify_keyword') && encodeURIComponent(Helpers.getValueFromUrl('shopify_keyword')),
        tags: Helpers.getValueFromUrl('label'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        orderType: isEstimate ? 'SALES_ESTIMATE' : (selectedOrderType ? selectedOrderType : 'SALES_ORDER,ANNUAL_MAINTENANCE_CONTRACT'),
        productSkuIds: selectedProductIds,
        sourceTenantId: Helpers.getValueFromUrl('source_tenant_id'),
      }, () => {
        setIsModalOpen(false);
        setSelectedRows([]);
        setSelectedRowKeys([]);
      });
    }
  }, [searchKeyword, currentPage, limit, call, selectedStatus, fulfillmentStatus, paymentStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedCustomStatus, shopifySearchKeyword, selectedTag, selectedAssignee, selectedProductIds, sourceTenantId, selectedOrderType, orderDateSelectedIntervalDateRangeType,
    // selectedFilterView,
  ]);

  const syncTimes = [
    {
      id: 3, time: '1 Hour', time_value: 60,
    },
    {
      id: 4, time: '4 Hours', time_value: 240,
    },
    {
      id: 5, time: '12 Hours', time_value: 720,
    },
    {
      id: 6, time: '24 Hours', time_value: 1440,
    },
  ];

  const getDataSource = (data) => {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      return copyData?.map((item) => ({ ...item, key: item?.order_id }));
    }
    return [];
  };

  const downloadHandler = () => {
    const visibleColumnKeys = Object.entries(visibleColumns)
      .filter(([key, value]) => value.visible)
      .map(([key]) => key.toLowerCase())
      .join(',');
    const numbersArray = [];
    const stringsArray = [];
    const dataList = visibleColumnKeys.split(',');
    dataList.forEach((item) => {
      if (!isNaN(item)) {
        numbersArray.push(Number(item));
      } else {
        stringsArray.push(item);
      }
    });

    const numbersString = numbersArray.join(',');
    const stringsString = stringsArray.join(',');
    const payload = {
      tenant_ids: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, (window.location.href.includes('/estimate')) ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','),
      search_keyword: Helpers.getValueFromUrl('keyword'),
      payment_status: Helpers.getValueFromUrl('payment_status'),
      from_date: Helpers.getValueFromUrl('startDate'),
      to_date: Helpers.getValueFromUrl('endDate'),
      columns: stringsString,
      custom_fields: numbersString,
      emails: selectedEmails,
      type: 'send_email',
      level: reportType,
      tags: Helpers.getValueFromUrl('label'),
      fulfillment_status: Helpers.getValueFromUrl('fulfillment_status'),
      custom_status: Helpers.getValueFromUrl('custom_status'),
      department_id: Helpers.getValueFromUrl('department'),
      order_type: isEstimate ? 'SALES_ESTIMATE' : 'SALES_ORDER',
      accountManagerIds: Helpers.getValueFromUrl('accountManager'),
      userId: user?.user_id,
    };
    if (!downloadSoListLoading) {
      downloadSoList(payload, () => {
        setOpenPopover(false);
      });
    }
  };

  const getCustomStatusData = () => {
    if (window.location.href.includes('/estimate')) {
      return customStatusSalesEstimate;
    }
    return customStatusSalesOrder;
  };

  const getCustomStatusLoading = () => {
    if (window.location.href.includes('/estimate')) {
      return getCustomStatusSalesEstimateLoading;
    }
    return getCustomStatusSalesOrderLoading;
  };
  const allTenants = Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ);

  const statusOptions = [
    { value: null, label: "All Status" },
    ...getCustomStatusData()?.statuses?.map((item) => ({
      value: item?.status_name,
      label: item?.status_name?.split('_')?.join(' ')?.toProperCase(),
    })) || []
  ];

  return (
    <Fragment>
      <Drawer
        onClose={() => setOcrDrawer(false)}
        open={ocrDrawer}
        width="800"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '750px' }}>
            <H3Text text={`Create ${documentUINames.uiName?.toLowerCase()} with automatic document scanning`} className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOcrDrawer(false)} />
          </div>
          <div style={{ paddingTop: '60px' }}>
            <OCRFileUploader
              entityName="purchase_order"
            />
          </div>
        </div>
      </Drawer>
      <Modal
        title={(
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              alt="shopify icon"
              src={ShopifyIcon}
              width={24}
              height={24}
              style={{ marginRight: 10 }}
            />
            <div>Search for Shopify Order</div>
          </div>
        )}
        getContainer={() => document.querySelector('.trigger-modal-btn')}
        style={{
          top: '17px',
          left: isMobileOrPortrait ? '-1%' : '6%',
          width: '520px',
        }}
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);
          setTimeout(() => {
            document.querySelectorAll('#z-index-1000').forEach((element) => {
              element.style.setProperty('z-index', '1000', 'important');
            });
          }, 500);
        }}
        onCancel={() => {
          setIsModalOpen(false);
          setShopifyKeyword(null);
          setShopifySearchKeyword(null);
          setTimeout(() => {
            document.querySelectorAll('#z-index-1000').forEach((element) => {
              element.style.setProperty('z-index', '1000', 'important');
            });
          }, 500);
        }}
        footer={null}
        mask
        maskClosable
        closeIcon={null}
      >
        <div className="section-search">
          <div className="section-search-bar__wrapper" style={{ width: '100%' }}>
            <div className="section-search-bar">
              <input
                value={shopifyKeyword}
                placeholder="Search by comma separated Shopify Order Id... eg.#1135,#1146"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setShopifySearchKeyword(e.target.value);
                    setCurrentPage(1);
                  }
                }}
                onChange={(event) => {
                  setShopifyKeyword(event.target.value);
                }}
              />
              {!getOrderDataLoading() ? (
                <H3Image
                  src={searchIcon}
                  className="section-search-bar__icon"
                  alt="search"
                  onClick={() => {
                    setShopifySearchKeyword(keyword);
                    setCurrentPage(1);
                  }}
                />
              ) : (
                <LoadingOutlined />
              )}
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        title={(
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              alt="shopify icon"
              src={searchIcon} // Make sure 'searchIcon' is defined and imported
              width={20}
              height={20}
              style={{ marginRight: 10 }}
            />
            <div>Search By Product Name</div>
            &nbsp;  &nbsp;
            {getProductsLoading && <Spin size="small" />}
          </div>
        )}
        getContainer={() => document.querySelector('.trigger-modal-btn')}
        style={{
          top: '17px',
          left: isMobileOrPortrait ? '-1%' : '6%',
          width: '520px',
        }}
        open={isModalProductNameOpen}
        onOk={() => {
          setIsModalProductNameOpen(false);
          setTimeout(() => {
            document.querySelectorAll('#z-index-1000').forEach((element) => {
              element.style.setProperty('z-index', '1000', 'important');
            });
          }, 500);
        }}
        onCancel={() => {
          setIsModalProductNameOpen(false);
          setTimeout(() => {
            document.querySelectorAll('#z-index-1000').forEach((element) => {
              element.style.setProperty('z-index', '1000', 'important');
            });
          }, 500);
        }}
        footer={null}
        mask
        maskClosable
        closeIcon={null}
      >
        <div className="section-search">
          <div className="section-search-bar__wrapper" style={{ width: '100%' }}>
            <PRZSelect
              showSearch
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Select a product"
              optionFilterProp="children"
              onSearch={(value) => setSearchByProduct(value)}
              value={selectedProductIds}
              onChange={handleChange}
              loading={getProductsLoading}
              filterOption={(input, option) => option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0}
            >
              {products?.result?.products?.map((product) => (
                <Option key={product.product_sku_id} value={product.product_sku_id}>
                  {product?.product_info?.product_sku_name}
                </Option>
              ))}
            </PRZSelect>
          </div>
        </div>
      </Modal>

      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedOrder?.sales_order_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedOrder?.custom_fields}
          documentData={selectedOrder}
          fields={ListScreenKeys({
            documentData: selectedOrder, isEstimate, user,
          })}
        />
      </Drawer>

      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">

            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        // placeholder={`Search for Sales ${isEstimate ? 'Estimate' : 'Order'}...`}
                        placeholder={`Search ${documentUINames.uiName}...`}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="section-search">
                  <div className="search-by-product-modal-btn">
                    <H3Text
                      text={(
                        <div
                          className="new-action-button-wrapper"
                          onClick={() => {
                            document.querySelectorAll('#z-index-1000').forEach((element) => {
                              element.style.setProperty('z-index', '0', 'important');
                            });
                            setIsModalProductNameOpen(true);
                          }}
                        >
                          <Fragment>
                            <div className="action-button-text">Search By Products </div>
                            <div className="action-button-text_mobile">Search</div>
                            &nbsp;  &nbsp;
                            <H3Image src={searchIcon} className="action-button-icon" />
                          </Fragment>
                        </div>
                      )}
                      className="action-button action-button-big"
                    />
                  </div>
                </div>
                {!isEstimate && !!user?.user_tenants?.filter((userTenant) => userTenant?.shopify_location_id)?.length && (
                  <div className="trigger-modal-btn">
                    <H3Text
                      text={(
                        <div
                          className="new-action-button-wrapper"
                          onClick={() => {
                            document.querySelectorAll('#z-index-1000').forEach((element) => {
                              element.style.setProperty('z-index', '0', 'important');
                            });
                            setIsModalOpen(true);
                          }}
                        >
                          <Fragment>
                            <H3Image src={ShopifyIcon} className="action-button-icon" />
                            <div className="action-button-text">Search</div>
                          </Fragment>
                        </div>
                      )}
                      className="action-button action-button-big"
                    />
                  </div>
                )}
              </div>
              <div className="doc-list__header-wrapper__right">
                {/*
                {!isEstimate && user?.tenant_info?.default_shopify_tenant_id === user?.tenant_info?.tenant_id
                  && (
                    <Dropdown
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onOpenChange={(flag) => setOpen(flag)}
                      open={open}
                      overlay={(
                        <Fragment>
                          <div className="select-sync-time__wrapper">
                            <div className="select-sync-time__head">
                              Sync Shopify orders
                            </div>
                            <div className="select-sync-time__body">
                              <Menu>
                                <Menu.Item>
                                  <Radio.Group onChange={(event) => setSelectedDuration(event?.target?.value)} value={selectedDuration}>
                                    {syncTimes?.map((syncTime) => <Radio key={syncTime?.id} value={syncTime?.time_value}>{`Past ${syncTime?.time}`}</Radio>)}
                                  </Radio.Group>
                                </Menu.Item>
                              </Menu>
                            </div>
                            <div className="select-sync-time__footer">
                              <H3Button
                                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                text={!syncShopifyOrdersLoading ? 'Sync Orders' : <LoadingOutlined />}
                                onClick={() => {
                                  syncShopifyOrders({
                                    org_id: user?.tenant_info?.org_id,
                                    shop_name: user?.tenant_info?.shop_name,
                                    time: selectedDuration,
                                  }, () => {
                                    setOpen(false);
                                    setCall(true);
                                  });
                                }}
                                customClass="select-sync-time__footer-button"
                              />
                            </div>
                          </div>
                        </Fragment>
                      )}
                      trigger={['click']}
                      overlayStyle={{ width: '150px' }}
                      placement="bottomRight"
                    >
                      <H3Text
                        text={(
                          <div className="new-action-button-wrapper" onClick={(e) => e.preventDefault()}>
                            {!syncShopifyOrdersLoading ? (
                              <Fragment>
                                <H3Image src={ShopifyIcon} className="action-button-icon" />
                                <div className="action-button-text">Sync</div>
                              </Fragment>
                            )
                              : (
                                <div style={{ minWidth: '60px', textAlign: 'center' }}>
                                  <LoadingOutlined style={{ width: '16px !important', margin: 'auto' }} />
                                </div>
                              )}
                          </div>
                        )}
                        className="action-button action-button-big"
                      />
                    </Dropdown>
                  )} */}

                {Helpers.getPermission((window.location.href.includes('/estimate')) ? Helpers.permissionEntities.SALES_ESTIMATE : (Helpers.permissionEntities.SALES_ORDER || Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT),
                  Helpers.permissionTypes.CREATE, user) && !SoFromMrp && (
                    <div className="doc-list__buttons-wrapper">
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        // text={isEstimate ? '+ New Estimate' : '+ New Sales Order'}
                        text={`+ New ${documentUINames.uiName}`}
                        onClick={() => {
                          if (isEstimate) {
                            history.push('/sales/estimate/create');
                          } else {
                            history.push('/sales/sales-orders/create');
                          }
                        }}
                        customClass="add-button hide__in-mobile"
                      />
                      {!isEstimate && (
                        <H3Button
                          buttonType={defaultButtonTypes.BLUE_ROUNDED}
                          text={(
                            <React.Fragment>
                              <img className="ai-icon-for-ocr" style={{ filter: 'none' }} src={Ai} alt="premium" />
                              {' '}
                              Auto Scan
                            </React.Fragment>
                          )}
                          onClick={() => {
                            setOcrDrawer(true);
                          }}
                          customClass="ocr-button"
                        />
                      )}
                    </div>
                  )}
              </div>
            </div>

            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setShopifySearchKeyword(tempFilterValues.shopify_keyword);
                    setKeyword(tempFilterValues.keyword);
                    setShopifyKeyword(tempFilterValues.shopify_keyword);
                    setSelectedCustomStatus(tempFilterValues.custom_status);
                    setSelectedCustomStatusId(tempFilterValues.custom_status_id);
                    setFulfillmentStatus(tempFilterValues.fulfillment_status);
                    setPaymentStatus(tempFilterValues.payment_status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedTag(tempFilterValues.label);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setSelectedAssignee(tempFilterValues.accountManager);
                    setSelectedOrderType(tempFilterValues.order_type);
                    setSelectedDepartment(tempFilterValues.department);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={(window.location.href.includes('/estimate')) ? entityNameEnum.SALES_ESTIMATE : entityNameEnum.SALES_ORDER}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {selectedOrderType && !isEstimate && (
                  <Tag closable={Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) && Helpers.getPermission(Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT, Helpers.permissionTypes.READ, user) && (user?.tenant_info?.sales_config?.sub_modules?.sales_order?.is_active && user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.is_active)} onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Selected Order Type
                    &nbsp;
                    <span><b>{selectedOrderType.split('_').join(' ')}</b></span>
                  </Tag>
                )}
                {shopifySearchKeyword && (
                  <Tag closable onClose={() => { setShopifySearchKeyword(''); setShopifyKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for shopify# -
                    &nbsp;
                    <span><b>{shopifySearchKeyword.replace(/\s/g, '')}</b></span>
                  </Tag>
                )}
                {selectedStatus && (
                  <Tag closable onClose={() => {
                    setSelectedStatus(null);
                    setCurrentPage(1);
                    }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedCustomStatus && (
                  <Tag closable onClose={() => {
                    setSelectedCustomStatus(null);
                    setCurrentPage(1);
                    setSelectedCustomStatusId('');
                    }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedCustomStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {fulfillmentStatus && (
                  <Tag closable onClose={() => { setFulfillmentStatus(null); setCurrentPage(1);}} color="#2d7df7">
                    Fulfillment Status -
                    &nbsp;
                    <span><b>{fulfillmentStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {paymentStatus && (
                  <Tag closable onClose={() => { setPaymentStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Payment Status -
                    &nbsp;
                    <span><b>{paymentStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {sourceTenantId && sourceTenantId?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSourceTenantId(sourceTenantId?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Source Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {
                  selectedProductIds?.length > 0 && selectedProductIds?.map((item, index) => (
                    <Tag
                      key={index}
                      closable
                      onClose={() => {
                        setSelectedProductIds(selectedProductIds?.filter((id) => id !== item));
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      Product -
                      &nbsp;
                      <span><b>{selectedProducts?.find((product) => product.value === item)?.children}</b></span>
                    </Tag>
                  ))
                }
                {selectedTag && selectedTag?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTag(selectedTag?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Label -
                    &nbsp;
                    <span>
                      <b>{item?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setOrderDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      {/* {`${(getOrderData() && getOrderData()?.data?.count) ? getOrderData()?.data?.count : '0'} ${isEstimate ? 'Estimates' : 'Sales Orders'}`} */}
                      {`${(getOrderData() && getOrderData()?.data?.count) ? getOrderData()?.data?.count : '0'} ${documentUINames.uiName}`}
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <div className="select-user__filter-wrapper">
                          <SelectUser
                            selectedUsers={selectedAssignee}
                            onSelect={(userId) => {
                              setCurrentPage(1)
                              setSelectedAssignee([...selectedAssignee, {
                                userId,
                                title: userId === 0 ? 'Unassigned' : `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                                identity: userId === 0 ? 'UA' : orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                              }]);
                            }}
                            onRemove={(userId) => {
                              setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                            }}
                            disabled={(window.location.href.includes('/estimate')) ? (user?.tenant_info?.sales_config?.sub_modules?.sales_estimate?.settings?.restrict_estimate_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_estimate)) : (user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.restrict_orders_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_so))}
                          />
                        </div>

                        {
                          getOrderData() && getOrderData()?.data?.count > 0
                          && (
                            <Popover
                              placement="bottom"
                              trigger="click"
                              title={<div>Please provide your email address</div>}
                              open={openPopover}
                              onOpenChange={() => setOpenPopover(!openPopover)}
                              content={(
                                <React.Fragment>
                                  <div>
                                    <PRZSelect
                                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                      mode="tags"
                                      filterOption={false}
                                      value={selectedEmails}
                                      onChange={(value) => setSelectedEmails(value)}
                                      disabled={downloadSoListLoading}
                                      maxTagCount="responsive"
                                      style={{
                                        borderRadius: '2px',
                                        width: '300px',
                                        fontSize: '13px',
                                        paddingTop: '2px',
                                        height: 'auto !important',

                                      }}
                                    >

                                      {selectedEmails.length > 0 ? (
                                        selectedEmails.map((item) => (
                                          <Option key={item} value={item}>
                                            {item}
                                          </Option>
                                        ))
                                      ) : (
                                        <Option key={user?.email} value={user?.email}>
                                          {user?.email}
                                        </Option>
                                      )}

                                    </PRZSelect>
                                  </div>
                                  <div className="mg-top-10">
                                    <Radio.Group
                                      onChange={(event) => setReportType(event?.target?.value)}
                                      disabled={downloadSoListLoading}
                                      value={reportType}
                                    >
                                      <Space direction="vertical">
                                        {/* <Radio key="1" value="document_level">{isEstimate ? 'Estimate Data' : 'Sales Orders Data'}</Radio>
                                        <Radio key="2" value="line_level">{`${isEstimate ? 'Estimate' : 'Sales Order'} Items Data`}</Radio> */}
                                        <Radio key="1" value="document_level">{`${documentUINames.uiName} Data`}</Radio>
                                        <Radio key="2" value="line_level">{`${documentUINames.uiName} Items Data`}</Radio>
                                      </Space>
                                    </Radio.Group>

                                  </div>
                                  <div>
                                    <H3Button
                                      text="Send"
                                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                      onClick={() => { downloadHandler(); }}
                                      customClass="email-submit"
                                      isLoading={downloadSoListLoading}
                                      disabled={downloadSoListLoading}
                                    >
                                      Send

                                    </H3Button>
                                  </div>

                                </React.Fragment>
                              )}
                            >
                              <div
                                className={`download-btn ${downloadSoListLoading ? 'download-btn__disabled' : ''}`}
                                onClick={() => {
                                  setOpenPopover(true);
                                }}
                              >
                                <H3Text
                                  text={(
                                    <FontAwesomeIcon icon={faDownload} />
                                  )}
                                  className="action-button"
                                />
                              </div>
                            </Popover>

                          )
                        }
                        {!isEstimate && selectedRowKeys?.length > 0 && (
                          <BulkSOActions
                            selectedCustomStatus={selectedCustomStatus}
                            selectedCustomStatusId={selectedCustomStatusId}
                            setSelectedCustomStatusId={(val) => setSelectedCustomStatusId(val)}
                            selectedRowKeys={selectedRowKeys}
                            selectedRows={selectedRows}
                            callback={() => {
                              setSelectedRowKeys([]);
                              setSelectedRows([]);
                              setCall(!call);
                            }}
                            selectedTenant={selectedTenant}
                          />
                        )}
                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                        <Dropdown
                          trigger={['click']}
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Select Business Unit </div>
                                <TenantSelector
                                  selectedTenant={selectedTenant}
                                  showSearch
                                  showAll={false}
                                  noDropdownAlign
                                  isMultiple
                                  onChange={(value) => {
                                    setCurrentPage(1);
                                    setSelectedTenant(value);
                                  }}
                                  placeholder="Select Business Unit"
                                  hideTitle
                                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)}
                                />
                              </div>
                              {!isEstimate && (
                                <div className="filter__container filter__container-section">
                                  <div className="filter__title">Source Business Unit</div>
                                  <TenantSelector
                                    selectedTenant={sourceTenantId}
                                    showSearch
                                    onChange={(value) => {
                                      setSourceTenantId(value);
                                    }}
                                    placeholder="Select Business Unit"
                                    isMultiple
                                    hideTitle
                                    includedTenants={allTenants?.filter((item) => item !== user?.tenant_info?.tenant_id)}
                                  />
                                </div>
                              )}
                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Select Department </div>
                                <div className="sales-orders__header__section-status">
                                  <SelectDepartment
                                    title="Select Department"
                                    hideTitle
                                    selectedDepartment={Number(selectedDepartment) || ''}
                                    noDropdownAlign
                                    onChange={(value) => {
                                      setSelectedDepartment(value?.department_id.toString() || '');
                                      setCurrentPage(1);
                                    }}
                                    disabled={departmentLevelVisibility}
                                  />
                                </div>
                              </div>
                              <div className="filter__container filter__container-section">
                                {/* <div className="filter__title">{isEstimate ? 'Estimate Status' : 'Order Status'}</div> */}
                                <div className="filter__title">{`${documentUINames.uiName} Status`}</div>
                                <PRZSelect
                                  value={selectedCustomStatus}
                                  onChange={(value) => {
                                    const requiredStatus = getCustomStatusData()?.statuses?.filter((status) => status?.status_name === value)[0];
                                    setSelectedCustomStatus(requiredStatus?.status_name);
                                    setSelectedCustomStatusId(requiredStatus?.custom_status_id);
                                    setSelectedRowKeys(null);
                                    setSelectedRows(null);
                                    setCurrentPage(1);
                                  }}
                                  placeholder="Order Status"
                                  options={statusOptions}
                                />
                              </div>

                              {!isEstimate && (
                                <div className="filter__container filter__container-section">
                                  <div className="filter__title"> Fulfillment Status </div>
                                  <div
                                    className="sales-orders__header__section-status"
                                  >
                                    <PRZSelect
                                      value={fulfillmentStatus}
                                      onChange={(value) => {
                                        setFulfillmentStatus(value);
                                        setCurrentPage(1);
                                      }}
                                      placeholder="Order Fulfillment Status"
                                    >
                                      <Option key={null} value={null}> All Fulfillment Status</Option>
                                      {fulfillmentStatues?.map((item) => <Option key={item} value={item.value}>{item.label}</Option>)}
                                    </PRZSelect>
                                  </div>
                                </div>
                              )}

                              {!isEstimate && (
                                <div className="filter__container filter__container-section">
                                  <div className="filter__title"> Payment Status </div>
                                  <div
                                    className="sales-orders__header__section-status"
                                  >
                                    <PRZSelect
                                      value={paymentStatus}
                                      onChange={(value) => {
                                        setPaymentStatus(value);
                                        setCurrentPage(1);
                                      }}
                                      placeholder="Order Payment Status"
                                    >
                                      <Option key={null} value={null}> All Payment Status</Option>
                                      {paymentStatues?.map((item) => <Option key={item} value={item.value}>{item.label}</Option>)}
                                    </PRZSelect>
                                  </div>
                                </div>
                              )}

                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Select Labels </div>
                                <div className="sales-orders__header__section-status">
                                  <TagSelector
                                    filter
                                    entityType="SALES_ORDER"
                                    selectedTags={selectedTag}
                                    showSearch
                                    showAll={false}
                                    noDropdownAlign
                                    isMultiple
                                    onChange={(value) => {
                                      setCurrentPage(1);
                                      setSelectedTag(value);
                                    }}
                                    placeholder="Select Label"
                                    hideTitle
                                    hideCSS
                                  />
                                </div>
                              </div>

                              {!isEstimate && (
                                <div className="filter__container filter__container-section">
                                  <div className="filter__title"> Select Order Type </div>
                                  <PRZSelect
                                    value={selectedOrderType}
                                    onChange={(value) => {
                                      setSelectedOrderType(value);
                                      setCurrentPage(1);
                                    }}
                                    placeholder="Order Type"
                                    disabled={!(Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) && Helpers.getPermission(Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT, Helpers.permissionTypes.READ, user)) || !(user?.tenant_info?.sales_config?.sub_modules?.sales_order?.is_active && user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.is_active)}
                                  >
                                    <Option key={null} value={null}> All Order Types</Option>
                                    <Option key="SALES_ORDER" value="SALES_ORDER">Sales Order</Option>
                                    <Option key="ANNUAL_MAINTENANCE_CONTRACT" value="ANNUAL_MAINTENANCE_CONTRACT">AMC Sales Order</Option>
                                  </PRZSelect>
                                </div>
                              )}

                            </div>
                          )}
                        >
                          <div className="doc-list__action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={(value) => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                          localStorage.setItem('prcz-page-columns-so', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={(value) => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                            localStorage.setItem('prcz-page-columns-so', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                scroll={!isMobileOrPortrait && !!getDataSource(getOrderData()?.data?.sales_orders)?.length ? { x: 'max-content', y: 'calc(100dvh - 170px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!getDataSource(getOrderData()?.data?.sales_orders)?.length}
                loading={
                  getOrderDataLoading()
                  || syncSOLoading
                  || getDocCFV2Loading
                  || updateSOStatusLoading
                  || getCustomStatusLoading()
                  || savedFilterViewsLoading
                }
                showHeader
                size="small"
                columns={getSalesOrderColumns()}
                dataSource={getDataSource(getOrderData()?.data?.sales_orders) || []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: getOrderData() ? getOrderData()?.data?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10 ,25, 50, 100],
                  }
                }
                rowSelection={!isMobileOrPortrait ? {
                  onChange: (rowKeys, rows) => {
                    setSelectedRowKeys(rowKeys);
                    setSelectedRows(rows);
                  },
                  selectedRowKeys,
                } : false}
                bordered
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, SOReducers, UnicommerceIntegrationReducers, ShopifyIntegrationReducers, CFV2Reducers, DepartmentReducers, CustomStatusReducers, TenantReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getSOLoading: SOReducers.getSOLoading,
  getEstimateLoading: SOReducers.getEstimateLoading,
  salesOrders: SOReducers.salesOrders,
  salesEstimate: SOReducers.salesEstimate,
  syncSOLoading: UnicommerceIntegrationReducers.syncSOLoading,
  syncShopifySOLoading: ShopifyIntegrationReducers.syncShopifySOLoading,
  syncShopifyOrdersLoading: ShopifyIntegrationReducers.syncShopifyOrdersLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsSalesOrder: CFV2Reducers.cfV2DocSalesOrder,
  customFieldsSalesOrderAMC: CFV2Reducers.cfV2DocAnnualMaintenanceContract,
  customFieldsSalesEstimate: CFV2Reducers.cfV2DocSalesEstimate,
  departments: DepartmentReducers.departments,
  updateSOStatusLoading: SOReducers.updateSOStatusLoading,
  customStatusSalesOrder: CustomStatusReducers.customStatusSalesOrder,
  customStatusSalesEstimate: CustomStatusReducers.customStatusSalesEstimate,
  getCustomStatusSalesOrderLoading: CustomStatusReducers.getCustomStatusSalesOrderLoading,
  getCustomStatusSalesEstimateLoading: CustomStatusReducers.getCustomStatusSalesEstimateLoading,
  downloadSoListLoading: SOReducers.downloadSoListLoading,
  orgUsers: TenantReducers.orgUsers,
  products: ProductReducers.products,
  getProductsLoading: ProductReducers.getProductsLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getSO: (payload, callback) => dispatch(SOActions.getSO(payload, callback)),
  updateSOStatus: (payload, callback) => dispatch(SOActions.updateSOStatus(payload, callback)),
  syncSO: (payload, callback) => dispatch(
    UnicommerceIntegrationActions.syncSO(payload, callback),
  ),
  syncShopifySO: (payload, callback) => dispatch(
    ShopifyIntegrationActions.syncShopifySO(payload, callback),
  ),
  syncShopifyOrders: (payload, callback) => dispatch(
    ShopifyIntegrationActions.syncShopifyOrders(payload, callback),
  ),
  getDocCFV2: (paylaod, callback) => dispatch(CFV2Actions.getDocCFV2(paylaod, callback)),
  getDocCFV2Success: (customFieldsDocV2) => dispatch(CFV2Actions.getDocCFV2Success(customFieldsDocV2)),
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
  downloadSoList: (payload, callback) => dispatch(SOActions.downloadSoList(payload, callback)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SalesOrderList));
